<div class="dialog-container">
  <div class="title">
    <mat-icon>view_list</mat-icon>
    <span>Assigned accounts</span>
  </div>
  @if (isLoading) {
    <div class="loading-container">
      <p>Getting information...</p>
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  }
  @if (!isLoading) {
    <div class="content">
      <mat-card-subtitle
        >Please select the account where you want to operate</mat-card-subtitle
        >
        <mat-card-subtitle>Assigned Account</mat-card-subtitle>
        <div class="table">
          @for (account of dataToDisplay?.accounts; track account) {
            <div
              class="assigned-account"
              (click)="onAccountRowClick(account.id)"
              >
              <div class="assigned-account-name">
                <p>{{ account.name }}</p>
              </div>
              <div class="assigned-account-radio">
                <mat-radio-button
                  id="{{ account.id }}"
                  [checked]="account.selected"
                  (change)="onAccountSelectedChange($event.source.id)"
                  labelPosition="before"
                  >
                  @if (account.selected) {
                    <p class="selected">Selected</p>
                  }
                </mat-radio-button>
              </div>
            </div>
          }
        </div>
        <div>
          <mat-card-subtitle>User details</mat-card-subtitle>
        </div>
        <div class="user-details-container">
          <div class="user-details">
            <p>First Name</p>
            <h3>{{ dataToDisplay.firstName }}</h3>
          </div>
          <div class="user-details">
            <p>Last Name</p>
            <h3>{{ dataToDisplay.lastName }}</h3>
          </div>
          <div class="user-details">
            <p>User Email</p>
            <h3>{{ dataToDisplay.email }}</h3>
          </div>
        </div>
      </div>
    }
    @if (!isLoading) {
      <div class="actions">
        <button id="cancel-multioffice-select" (click)="cancel()" mat-button>
          CANCEL
        </button>
        <button
          id="apply-multioffice-select"
          [disabled]="!canConfirm"
          (click)="onApplyButton()"
          mat-button
          color="primary"
          >
          APPLY
        </button>
      </div>
    }
  </div>
